import axios from "axios";
import { auth } from "../firebase";

/* IF any of the validation method changes then change accordingly on the server */
const Utils = {
  /** Update logic on server as well when changed */
  validateName: (name) => {
    return name && name.trim().length > 1 && /^[A-Za-z0-9\s]+$/.test(name);
  },

  /** Update on server as well, when changed */
  validateEmail: (email) => {
    return email && /\S+@\S+\.\S+/.test(email);
  },

  /** Makes a json request to the cloud functions, returns an object with promise and cancel option */
  request: async (url, method = "POST", data) => {
    const token = await auth.currentUser.getIdToken();
    let requestObj = {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        lang: "en",
      },
    };
    if (method.toLowerCase() === "post" && data) {
      requestObj.data = JSON.stringify(data);
    }

    let response = await axios(url, requestObj);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message);
    }
  },

  capitalizeFirstLetter: (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
};

export default Utils;
